import { render, staticRenderFns } from "./AssignExceptionsComponent.vue?vue&type=template&id=042bce55&scoped=true&"
import script from "./AssignExceptionsComponent.vue?vue&type=script&lang=ts&"
export * from "./AssignExceptionsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AssignExceptionsComponent.vue?vue&type=style&index=0&id=042bce55&scoped=true&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "042bce55",
  null
  
)

export default component.exports